export default __webpack_public_path__ + "static/media/logo-06-kempinski.b34a8ad5.png";